class isPWA {
  isPWA: boolean | undefined

  set(isPWA?: boolean) {
    this.isPWA = isPWA
  }
}

export default new isPWA()
